function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    rx: 9.5,
    style: {
      opacity: 0.8,
      fill: "none",
      stroke: "#9c1d25",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line Copy 4",
    d: "M0 3.393 4.372 0",
    transform: "matrix(.998 -.07 .07 .998 6.719 5.741)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#9c1d25",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line Copy 5",
    d: "m0 0 4.372 3.393",
    transform: "matrix(.998 .07 -.07 .998 6.955 9.552)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#9c1d25",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon_back.5e984af83300fd142fac99b35409c80b.svg";
export { ForwardRef as ReactComponent };